import { SaleSheetUpload } from '../../pages';

import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const SaleSheetUploadContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const uploadClick = async payload => {
		setUploaded(true);
	};
	return (
		<SaleSheetUpload
			closeModal={closeModal}
			uploaded={uploaded}
			uploadClick={uploadClick}
			file={file}
			selectClick={selectClick}
			loading={loading}
		/>
	);
};

export default SaleSheetUploadContainer;
